import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=d9d7c08c&scoped=true&lang=pug&"
import script from "./CourseItem.vue?vue&type=script&lang=ts&"
export * from "./CourseItem.vue?vue&type=script&lang=ts&"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=d9d7c08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d7c08c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
